import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { C_Button } from "../../components/Common/CommonButton";
import { C_DatePicker, C_Select } from "../../CustomValidateForm";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, pageId } from "../../routes/index"
import { MetaTags } from "react-meta-tags";
import { GoButton_For_GenericSale_Action, GoButton_For_GenericSale_Success } from "../../store/Report/GenericSaleRedux/action";
import { BreadcrumbShowCountlabel, commonPageField, commonPageFieldSuccess } from "../../store/actions";
import DynamicColumnHook from "../../components/Common/TableCommonFunc";
import { ExcelReportComponent } from "../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { changeCommonPartyDropDetailsAction } from "../../store/Utilites/PartyDrodown/action";
import { allLabelWithBlank } from "../../components/Common/CommonErrorMsg/HarderCodeData";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { globalTableSearchProps } from "../../components/Common/SearchBox/MySearch";
import GlobalCustomTable from "../../GlobalCustomTable";
import { getGroupTypeslist } from "../../store/Administrator/GroupTypeRedux/action";
import { customAlert } from "../../CustomAlert/ConfirmDialog";

const PRIMARY_GROUP_TYPE = { value: 1, label: "Primary", IsPos: false };

const GenericSaleReport = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const userAdminRole = _cfunc.isAdminDivisionRole();
    const userPickedGroupType = useRef(false);
    const [headerFilters, setHeaderFilters] = useState('');
    const [userPageAccessState, setUserAccState] = useState('');
    const [distributorDropdown, setDistributorDropdown] = useState([allLabelWithBlank]);
    const [tableData, setTableData] = useState([]);
    const [btnMode, setBtnMode] = useState(0);
    const [groupType, setGroupType] = useState(PRIMARY_GROUP_TYPE);
    const isFranchise = _cfunc.loginUserIsFranchisesRole()
    const showGroupType = _cfunc.isFoodERPDotIn()
    const franchiseOnlyFields = [
        "Loyalty_Couponcode",
        "Loyalty_Memberid",
        "Loyalty_Requestid",
        "PaymentMode1",
        "PaymentMode2",
        "PaymentMode1Amount",
        "PaymentMode2Amount",
        "PartyLocationName",
    ];
    const {
        goButtonData = [],
        pageField,
        userAccess,
        Distributor,
        partyDropdownLoading,
        groupTypeList,
        groupTypeLoading
    } = useSelector((state) => ({
        goButtonData: state.GenericSaleReportReducer.genericSaleGobtn,
        partyDropdownLoading: state.CommonPartyDropdownReducer.partyDropdownLoading,
        Distributor: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        groupTypeList: state.GroupTypeReducer.GroupType,
        groupTypeLoading: state.GroupTypeReducer.goBtnLoading,
    })
    );

    const { fromdate = currentDate_ymd, todate = currentDate_ymd } = headerFilters;

    // Featch Modules List data  First Rendering
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })
        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.GENERIC_SALE_REPORT))
        dispatch(getGroupTypeslist());
        if (_cfunc.CommonPartyDropValue().value > 0) {
            setDistributorDropdown([_cfunc.CommonPartyDropValue()]);
        }
        dispatch(BreadcrumbShowCountlabel(`Count:${0} currency_symbol ${0.00}`));
        dispatch(changeCommonPartyDropDetailsAction({ isShow: false }))//change party drop-down show false
        return () => {
            setTableData([]);
            dispatch(changeCommonPartyDropDetailsAction({ isShow: true }))//change party drop-down restore show state
            dispatch(GoButton_For_GenericSale_Success([]));
        }
    }, [])

    useEffect(() => {
        if (tableData.length === 0) {
            setBtnMode(0)
        }
    }, [tableData]);

    const Party_Option = Distributor.map(i => ({
        value: i.id,
        label: i.Name
    }));

    const [tableColumns] = DynamicColumnHook({ pageField, })
    const displayColumns = tableColumns.filter(col => {
        if (isFranchise) return true; // show everything

        return !franchiseOnlyFields.includes(col.dataField);
    });


    useEffect(() => {

        try {
            if ((goButtonData.Status === true) && (goButtonData.StatusCode === 200)) {
                setBtnMode(0);
                const { Data } = goButtonData
                if (btnMode === 2) {
                    ExcelReportComponent({      // Download CSV
                        pageField,
                        excelTableData: Data,
                        excelFileName: "Generic Sale Report"
                    })
                    dispatch(GoButton_For_GenericSale_Success([]));
                    setDistributorDropdown([allLabelWithBlank])
                }
                else {
                    const UpdatedTableData = Data.map((item, index) => {

                        return {
                            ...item, id: index + 1,
                        };
                    });
                    setTableData(UpdatedTableData);
                    dispatch(GoButton_For_GenericSale_Success([]));
                }
            }
            else if ((goButtonData.Status === true)) {
                setTableData([]);
            }
            setBtnMode(0);
        }
        catch (e) { }

    }, [goButtonData]);

    function excel_And_GoBtnHandler(e, Btnmode) {

        if (!groupType) {
            customAlert({ Type: 3, Message: "Please select Group Type" });
            return;
        }

        setBtnMode(Btnmode);

        var isDistributorDropdown = ''
        if (distributorDropdown[0].value === "") {
            isDistributorDropdown = Party_Option.filter(i => !(i.value === '')).map(obj => obj.value).join(',');
        }
        else {
            isDistributorDropdown = distributorDropdown.filter(i => !(i.value === '')).map(obj => obj.value).join(',');
        }
        const jsonBody = JSON.stringify({
            "FromDate": fromdate,
            "ToDate": todate,
            "Party": !(userAdminRole) ? _cfunc.loginPartyID().toString() : isDistributorDropdown,
            "Group_Type": groupType.value,
        });

        let config = { jsonBody }
        dispatch(GoButton_For_GenericSale_Action(config));
    }

    function fromdateOnchange(e, date) {

        let newObj = { ...headerFilters }
        newObj.fromdate = date
        setHeaderFilters(newObj)
        setTableData([]);
    }

    function todateOnchange(e, date) {

        let newObj = { ...headerFilters }
        newObj.todate = date
        setHeaderFilters(newObj);
        setTableData([]);
    }

    function PartyDrodownOnChange(e = []) {

        if (e.length === 0) {
            e = [allLabelWithBlank]
        } else {
            e = e.filter(i => !(i.value === ''))
        }
        setDistributorDropdown(e);
        setTableData([]);
    }

    const apiGroupTypeOptions = (groupTypeList || []).map(i => ({
        value: i.id,
        label: i.Name,
        IsPos: i.IsPos,
    }));

    const isPrimaryOption = (i) => String(i.label).trim().toLowerCase() === "primary";

    // always keep Primary selectable, even if the API returns nothing
    const GroupType_Option = apiGroupTypeOptions.some(isPrimaryOption)
        ? apiGroupTypeOptions
        : [PRIMARY_GROUP_TYPE, ...apiGroupTypeOptions];

    // default: franchise -> POS, everyone else -> Primary
    useEffect(() => {
        if (userPickedGroupType.current) return;

        const primary = GroupType_Option.find(isPrimaryOption) || PRIMARY_GROUP_TYPE;
        const pos = GroupType_Option.find(i => i.IsPos === true);

        setGroupType(isFranchise && pos ? pos : primary);
    }, [groupTypeList]);

    function groupTypeOnChange(e) {
        userPickedGroupType.current = true;
        setGroupType(e);
        setTableData([]);
    }
    const labelStyle = { fontSize: "13px", fontWeight: 500, whiteSpace: "nowrap", marginBottom: "5px" };
    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>

            <div className="px-2 c_card_filter text-black mb-1">
                <div className="d-flex align-items-end flex-wrap mt-1 mb-2" style={{ gap: "6px 0", paddingBottom: "8px" }}>

                    {/* From Date */}
                    <div style={{ flex: "0 0 auto", padding: "0 16px 0 0" }}>
                        <FormGroup className="mb-0">
                            <Label className="mb-1" style={labelStyle}>From Date</Label>
                            <C_DatePicker
                                name="FromDate"
                                value={fromdate}
                                onChange={fromdateOnchange}
                            />
                        </FormGroup>
                    </div>

                    {/* To Date */}
                    <div style={{ flex: "0 0 auto", padding: "0 16px" }}>
                        <FormGroup className="mb-0">
                            <Label className="mb-1" style={labelStyle}>To Date</Label>
                            <C_DatePicker
                                name="ToDate"
                                value={todate}
                                onChange={todateOnchange}
                            />
                        </FormGroup>
                    </div>

                    {/* Party — admin only */}
                    {userAdminRole && (
                        <div style={{ flex: "1 1 220px", minWidth: "220px", maxWidth: "320px", padding: "0 16px" }}>
                            <FormGroup className="mb-0">
                                <Label className="mb-1" style={labelStyle}>Party</Label>
                                <C_Select
                                    name="Distributor"
                                    value={distributorDropdown}
                                    isSearchable={true}
                                    isMulti={true}
                                    isLoading={partyDropdownLoading}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    styles={{ menu: provided => ({ ...provided, zIndex: 3 }) }}
                                    options={Party_Option}
                                    onChange={PartyDrodownOnChange}
                                />
                            </FormGroup>
                        </div>
                    )}

                    {/* Group Type — compulsory */}
                    {showGroupType && (
                        <div style={{ flex: "0 0 200px", padding: "0 16px" }}>
                            <FormGroup className="mb-0">
                                <Label className="mb-1" style={labelStyle}>Group Type</Label>
                                <C_Select
                                    name="GroupType"
                                    value={groupType}
                                    isSearchable={true}
                                    isLoading={groupTypeLoading}
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    placeholder="Select Group Type"
                                    styles={{ menu: provided => ({ ...provided, zIndex: 3 }) }}
                                    options={GroupType_Option}
                                    onChange={groupTypeOnChange}
                                />
                            </FormGroup>
                        </div>
                    )}

                    {/* Buttons — pinned right on the same row */}
                    <div className="d-flex align-items-center ms-auto" style={{ gap: "8px" }}>
                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={btnMode === 1}
                            className="btn btn-success"
                            onClick={(e) => excel_And_GoBtnHandler(e, 1)}
                        >
                            Show
                        </C_Button>
                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={btnMode === 2}
                            className="btn btn-primary"
                            onClick={(e) => excel_And_GoBtnHandler(e, 2)}
                        >
                            Excel
                        </C_Button>
                    </div>

                </div>
            </div>



            <div className="mt-1">
                {/* <ToolkitProvider
                        keyField="id"
                        data={tableData}
                        columns={tableColumns}
                        search
                    >
                        {(toolkitProps,) => (
                            <React.Fragment>
                                <Row>
                                    <Col xl="12">
                                        <div className="table-responsive table" style={{ maxHeight: "77vh" }}>
                                            <BootstrapTable
                                                keyField="PartyID"
                                                classes={"custom-table"}
                                                noDataIndication={
                                                    <div className="text-danger text-center ">
                                                        Record Not available
                                                    </div>
                                                }
                                                onDataSizeChange={({ dataSize }) => {
                                                    dispatch(BreadcrumbShowCountlabel(`Count:${dataSize}`));
                                                }}
                                                {...toolkitProps.baseProps}
                                            />

                                            {globalTableSearchProps(toolkitProps.searchProps)}
                                        </div>
                                    </Col>
                                </Row>

                            </React.Fragment>
                        )}
                    </ToolkitProvider> */}


                <GlobalCustomTable
                    keyField="id"
                    data={tableData}
                    columns={displayColumns}
                    search
                    lazyLoading={100}

                    classes={"custom-table"}
                    noDataIndication={
                        <div className="text-danger text-center ">
                            Record Not available
                        </div>
                    }
                    onDataSizeChange={({ dataCount }) => {
                        dispatch(BreadcrumbShowCountlabel(`Count:${dataCount}`));
                    }}

                />

            </div>

        </React.Fragment >
    )
}

export default GenericSaleReport;